"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.search.js");
require("core-js/modules/es.string.trim.js");
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _lodash = _interopRequireDefault(require("lodash"));
var _moment = _interopRequireDefault(require("moment"));
var _lifehikesInitData = require("@/lifehikes-init-data");
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _ga = require("@/utils/ga");
var _hikeAdvancedReport = require("@/api/hike-advanced-report");
var _autoTableHeight = require("@/views/mixins/autoTableHeight");
var _index = _interopRequireDefault(require("../../../components/SearchBox/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'HikeAdvancedReportList',
  components: {
    SearchBox: _index.default
  },
  mixins: [_autoTableHeight.autoTableHeight],
  filters: {
    getInternalTitle: function getInternalTitle(value) {
      // console.log('row value', value)
      return typeof value === 'undefined' ? '' : value.title;
    }
  },
  data: function data() {
    return {
      tableLoading: false,
      total: 0,
      trainingStatus: _lifehikesInitData.trainingStatus,
      reportList: [],
      query: {
        page: 1,
        limit: 50,
        sort: '-start.utc',
        q: undefined,
        publish: undefined
      },
      checked: {
        drawTitle: '',
        id: '',
        title: true,
        internalTitle: true,
        description: true,
        eventDate: true,
        stages: true,
        report: true,
        stageDate: true,
        resources: true,
        tags: true,
        webinarInfo: true,
        clientName: true
      },
      basePublicUrl: ''
    };
  },
  created: function created() {
    var _this = this;
    return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.basePublicUrl = process.env.VUE_APP_PUBLIC_DOMAIN.trim();
            _context.n = 1;
            return _this.getList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    getUserPreviewUrl: function getUserPreviewUrl(reportId) {
      return process.env.VUE_APP_PUBLIC_DOMAIN.trim() + '/advanced/report/' + reportId;
    },
    getAdminPreviewUrl: function getAdminPreviewUrl(reportId) {
      return process.env.VUE_APP_PUBLIC_DOMAIN.trim() + '/advanced/report/' + reportId;
    },
    checkPermission: _permission.default,
    search: function search(pageNo) {
      this.query.page = pageNo;
      this.query.q = this.query.q === '' ? undefined : this.query.q;
      console.log('query:', this.query.q);
      this.getList();
    },
    deleteHikeAdvReport: function deleteHikeAdvReport(id, title) {
      var _this2 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var oEmail = (0, _cookie.getCookie)('EMAIL');
      var updatedPublishStatus = {
        id: id,
        publish: 'markdelete'
      };
      this.$confirm("This will delete [ ".concat(title, " ]. Continue?"), 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(function () {
        var data = {
          publish: 'markdelete'
        };
        (0, _hikeAdvancedReport.updateAdvancedReport)(token, id, data).then(function (response) {
          _this2.search(_this2.query.page);
          var msg = 'Hike cohort report is deleted';
          (0, _log.displayPopupMessage)(msg, 'success');
          (0, _ga.writeGaEvent)(_this2, 'HikeAdvancedReport', "".concat(_lifehikesInitData.userEvent.hikeAdvancedReport.delete), oEmail, "Hike Id: ".concat(id));
        }).catch(function (error) {
          (0, _log.displayPopupMessage)(error, 'error');
        });
      }).catch(function () {
        var msg = 'canceled';
        (0, _log.displayPopupMessage)(msg, 'info');
      });
    },
    getList: function getList() {
      var _this3 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tableLoading = true;
      (0, _hikeAdvancedReport.getAdvancedReports)(token, this.query).then(function (response) {
        _this3.reportList = response.data.rows;
        _this3.total = response.data.count;
        _this3.tableLoading = false;
      }).catch(function (error) {
        _this3.tableLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    isExipred: function isExipred(endUtc) {
      if (endUtc) {
        var now = _moment.default.utc();
        var end = _moment.default.utc(endUtc);
        return now > end;
      }
      return false;
    },
    sort: function sort(data) {
      var prop = data.prop,
        order = data.order;
      if (prop === 'title') {
        order === 'ascending' ? this.query.sort = '+title' : this.query.sort = '-title';
      }
      if (prop === 'start') {
        order === 'ascending' ? this.query.sort = '+start.utc' : this.query.sort = '-start.utc';
      }
      if (prop === 'end') {
        order === 'ascending' ? this.query.sort = '+end.utc' : this.query.sort = '-end.utc';
      }
      if (prop === 'description') {
        order === 'ascending' ? this.query.sort = '+description' : this.query.sort = '-description';
      }
      if (prop === 'publish') {
        order === 'ascending' ? this.query.sort = '+publish' : this.query.sort = '-publish';
      }
      if (prop === 'updatedAt') {
        order === 'ascending' ? this.query.sort = '+updatedAt' : this.query.sort = '-updatedAt';
      }
      if (prop === 'internal.title') {
        order === 'ascending' ? this.query.sort = '+internal.title' : this.query.sort = '-internal.title';
      }
      if (prop === 'internal.opportunityNumber') {
        order === 'ascending' ? this.query.sort = '+internal.opportunityNumber' : this.query.sort = '-internal.opportunityNumber';
      }
      this.search(1);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.query.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.query.page = val;
      this.getList();
    }
  }
};